module.exports = __webpack_public_path__ + "img/ycb.1be023aa.png";